import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useInvariableMemo } from '../invariable-hooks';
function useUrlParams(handler) {
    const params = useParams();
    const memoHandler = useInvariableMemo(() => handler);
    return useMemo(() => (memoHandler ? memoHandler.parse(params) : params), [params, memoHandler]);
}
export { useUrlParams };
//# sourceMappingURL=use-url-params.js.map